let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1DCjj")).then(() => parcelRequire('7ojdt'));